import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getModelDistributionMetrics } from '@/services/composer-dashboard/get-model-distribution-metrics';
import { ModelDistributionMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetModelDistributionMetrics = (
  options?: Omit<
    UseQueryOptions<ModelDistributionMetricsResponse, Error>,
    'queryKey' | 'queryFn'
  > & { labelIds?: string[] },
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;
  const { labelIds, ...queryOptions } = options ?? {};

  return useQuery<ModelDistributionMetricsResponse, Error>({
    queryKey: ['composer-model-distribution-metrics', orgId, labelIds ?? []],
    queryFn: () => getModelDistributionMetrics(orgId!, labelIds),
    retry: 1,
    staleTime: 60000,
    ...queryOptions,
    enabled: !!orgId && (queryOptions?.enabled ?? true),
  });
};
